<template>
  <Layout class="my-layout" v-if="showHtml">
    <Sider
      breakpoint="lg"
      collapsible
      :collapsed-width="78"
      width="180"
      v-model="isCollapsed"
    >
      <div class="logo-div">
        <img src="../assets/imgs/logo.png" alt />
      </div>
      <Menu
        width="auto"
        :class="menuitemClasses"
        @on-select="gotoPage"
        :open-names="openMenus"
        :active-name="currentPage"
        @on-open-change="menuChange"
        accordion
      >
        <div v-for="(item, index) in menuItems" :key="index">
          <Submenu v-if="item.children" :name="index" :class="item.type">
            <template slot="title">
              <Icon :size="item.size" :type="item.type" class="icon-menu" />
              <span>{{ item.title }}</span>
            </template>
            <div
              v-for="(subItem, i) in item.children"
              :key="index + i"
              class="submenu"
            >
              <MenuItem :name="subItem.name" v-if="subItem.checked">
                <span>{{ subItem.title }}</span>
              </MenuItem>
            </div>
          </Submenu>
          <MenuItem v-else :name="item.name" :class="item.type">
            <Icon :size="item.size" :type="item.type" class="icon-menu" />
            <span>{{ item.title }}</span>
          </MenuItem>
        </div>
      </Menu>
      <div slot="trigger"></div>
    </Sider>
    <Layout id="faBox">
      <Header :style="{ padding: '0 20px 0 36px' }" class="layout-header-bar">
        <span>{{ crumbs }}</span>
        <div class="rigthDropdown">
          <div class="ivu-dropdown">
            <a
              v-if="userinfo.Status == '学生'"
              style="vertical-align: middle"
              @click="showModal = true"
            >
              <Icon type="ios-notifications" size="22"></Icon>
              <span>通知</span>
            </a>
          </div>
          <Dropdown>
            <a href="javascript:void(0)">
              <Icon type="md-shirt" size="22"></Icon>
              <span>换肤</span>
              <Icon type="ios-arrow-down"></Icon>
            </a>
            <DropdownMenu slot="list">
              <DropdownItem @click.native="changeColor(1)">蓝色</DropdownItem>
              <DropdownItem @click.native="changeColor(2)">宝蓝</DropdownItem>
              <DropdownItem @click.native="changeColor(3)">铜绿</DropdownItem>
              <DropdownItem @click.native="changeColor(4)">裸粉</DropdownItem>
              <DropdownItem @click.native="changeColor(5)">群青</DropdownItem>
              <DropdownItem @click.native="changeColor(6)">驼色</DropdownItem>
            </DropdownMenu>
          </Dropdown>
          <Dropdown>
            <a href="javascript:void(0)">
              <Icon type="ios-contact" size="22" />
              <span>{{ userinfo.UserName }}</span>
              <Icon type="ios-arrow-down"></Icon>
            </a>
            <DropdownMenu slot="list">
              <DropdownItem @click.native="loginOut">退出账号</DropdownItem>
            </DropdownMenu>
          </Dropdown>
        </div>
      </Header>
      <Content
        :style="{ margin: '20px', background: '#fff' }"
        ref="box"
        id="content"
      >
        <keep-alive :include="keepAliveData">
          <!-- 子页面 -->
          <router-view />
        </keep-alive>
      </Content>
    </Layout>

    <!-- 公告信息 -->
    <Modal
      v-model="showModal"
      :mask-closable="false"
      title="消息通知"
      ok-text="取消"
      cancel-text
      class="MessageListObj"
    >
      <!-- 表格 -->
      <div v-if="MessageListObj.records > 0">
        <div
          v-for="(item, index) in MessageListObj.Result"
          :key="index"
          class="MessageList"
        >
          <div class="flexDiv">
            <div>{{ item.TeacherName }}</div>
            <div class="time">{{ item.CreateTime }}</div>
          </div>
          <div>消息内容：{{ item.Content }}</div>
        </div>
        <div class="page-div">
          <Page
            show-total
            :total="MessageListObj.records"
            :current="pageData.page"
            :page-size="pageData.size"
            @on-change="changePage"
          />
        </div>
      </div>
      <div v-else class="text-center" style="padding: 30px">暂无消息通知</div>
      <!-- 分页 -->
    </Modal>
  </Layout>
</template>
<script>
import Vue from "vue";
import axios from "axios";
import { resetTokenAndClearUser, getCookie } from "../utils";
import * as homeApi from "../api/home-api.js";
import { get, baseUrl } from "../apiconfig";
export default {
  name: "index",
  data() {
    return {
      showHtml: false,
      isCollapsed: false,
      // 用于储存页面路径
      paths: {},
      // 当前显示页面
      currentPage: "",
      openMenus: [], // 要打开的菜单名字 name属性
      menuCache: [], // 缓存已经打开的菜单
      showLoading: false, // 是否显示loading
      tagsArry: [],
      // 面包屑
      crumbs: "主页",
      userinfo: "",
      showModal: false,
      MessageListObj: {
        Result: [],
        page: 1,
        records: 0,
        total: 0,
      },
      pageData: {
        page: 1,
        size: 5,
      },
    };
  },
  beforeCreate() {
    // 换肤，默认显示theme1
  },
  computed: {
    rotateIcon() {
      return ["menu-icon", this.isCollapsed ? "rotate-icon" : ""];
    },
    menuitemClasses() {
      return ["menu-item", this.isCollapsed ? "collapsed-menu" : ""];
    },
    // 菜单栏
    menuItems() {
      return this.$store.state.menuItems;
    },
    // 需要缓存的路由
    keepAliveData() {
      this.tagsArry.map((item) => item.name);
      return this.tagsArry.map((item) => item.name);
    },
    nameToTitle() {
      const obj = {};
      this.menuItems.forEach((e) => {
        this.processNameToTitle(obj, e);
      });
      return obj;
    },
  },
  mounted() {
    this.info();
    this.getSkinView();
    if (this.userinfo.Status == "学生") {
      this.GetMessageList(1);
    }
  },
  methods: {
    // 页面初始化
    info() {
      // 第一个标签
      const name = this.$route.name;
      this.currentPage = name;

      this.tagsArry.push({
        title: this.nameToTitle[name],
        name: name,
      });

      this.crumbs = this.paths[name];
      // 设置用户信息
      this.userinfo = JSON.parse(sessionStorage.getItem("userinfo"));
    },
    // 跳转页面 路由名称和参数
    gotoPage(name) {
      this.currentPage = name;
      this.crumbs = this.paths[name];
      if (name == this.$route.name) {
        this.$router.push({
          path: "redirect",
          query: name,
        });
      } else {
        this.$router.replace({ name });
      }

      var index = this.crumbs.indexOf("/");
      if (index > 0) {
        var str = this.crumbs.slice(index + 1).trim();
        this.AddPageTime(str);
      } else {
        this.AddPageTime(this.crumbs);
      }
    },
    // 菜单栏改变事件
    menuChange(data) {
      this.menuCache = data;
    },
    processNameToTitle(obj, data, title) {
      if (data.name) {
        obj[data.name] = data.title;
        this.paths[data.name] = title ? `${title} / ${data.title}` : data.title;
      }
      if (data.children) {
        data.children.forEach((e) => {
          this.processNameToTitle(
            obj,
            e,
            title ? `${title} / ${data.title}` : data.title
          );
        });
      }
    },
    //更换主题
    changeColor(num) {
      homeApi
        .UpSkin({
          Theme: "theme" + num,
        })
        .then((res) => {
          if (res.success) {
            document.getElementById("body").className = "theme" + num;
          } else {
            document.getElementById("body").className = "theme1";
          }
        });
    },
    //获取主题颜色
    getSkinView() {
      homeApi.GetSkinView().then((res) => {
        this.showHtml = true;
        document.getElementById("body").className = res.Theme
          ? res.Theme
          : "theme1";
      });
    },
    // 退出登录
    loginOut() {
      if (getCookie("loginUser")){
        var mywin = window.open(baseUrl+"/sso/logout.php"); 
        setTimeout(function() {mywin.close();}, 500);
      }
      resetTokenAndClearUser();
      this.$router.push({
        name: "login",
      });
    },
    //记录页面访问时长
    AddPageTime(PageName) {
      homeApi.AddPageTime({ PageName: PageName }).then((res) => {});
    },
    // 获取学生公告
    GetMessageList(page) {
      homeApi
        .GetMessageList({ page: page, size: this.pageData.size })
        .then((res) => {
          this.MessageListObj = res;
        });
    },
    changePage(page) {
      this.GetMessageList(page);
    },
  },
  watch: {
    isCollapsed(val) {
      this.$store.state.isCollapsed = val;
    },
    // offsetTop
    $route: {
      handler: function (route) {},
      immediate: true,
    },
  },
};
</script>
<style>
</style>

